// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-card-property-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './card-property-skeleton.component.html',
  styleUrl: './card-property-skeleton.component.scss',
})
export class CardPropertySkeletonComponent {
  // inputs
  count = input<number>(1);
  containerClasses = input<string>();

  public counter(i: number) {
    return new Array(i);
  }
}
